module.exports = __webpack_public_path__ + "img/MAC1110_1-1.b5ca936b.jpg";